import React from 'react';
import { components } from 'react-select';
const renderPlaceholder = (Component = React.Fragment) => {
  const Placeholder = components.Placeholder;

  const PlaceholderWrapper = (placeholderProps) => {
    const { children, ...restProps } = placeholderProps;
    return (
      <Placeholder {...restProps}>
        <Component>{children}</Component>
      </Placeholder>
    );
  };

  PlaceholderWrapper.displayName = 'PlaceholderWrapper';

  return PlaceholderWrapper;
};

export default renderPlaceholder;
